import { IQuizMode, IUserQuestionAnswer } from 'utils/types';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface IOnGoingQuiz {
    courseId: string;
    quizId: string;
    title: string;
    timeLeft: number;
    questionIdsOrder: string[];
    quizAnswers: IUserQuestionAnswer[];
    currentQuestionIndex: number;
    progress: number;
    quizMode: IQuizMode;
    createdAt: string;
}
type IUnFinishedQuizStore = {
  quizzes: IOnGoingQuiz[];
  addQuiz: (quiz: IOnGoingQuiz) => void;
  updateQuiz: (quiz: IOnGoingQuiz) => void;
  removeQuiz: (quizId: string) => void;
  clearAll: () => void;
  hasQuiz: (quizId: string) => boolean;
};

export const useUnfinishedQuizStore = create<IUnFinishedQuizStore>()(
  persist(
    (set, get) => ({
        quizzes: [],
        updateQuiz(quiz) {
            set({ quizzes: get().quizzes.map((q) => (q.quizId === quiz.quizId ? 
                {...quiz, createdAt: new Date().toISOString()} : q)) });
        },
        addQuiz(quiz) {
            const { quizzes } = get();
            if (!quizzes.some((q) => q.quizId === quiz.quizId)) {
                if (quizzes.length >= 20) {
                    // remove the oldest quiz
                    get().removeQuiz(quizzes[0].quizId);
                }
                set({ quizzes: [...quizzes, {...quiz, createdAt: new Date().toISOString()}] });
            }
        },

        removeQuiz(quizId) {
            set({ quizzes: get().quizzes.filter((q) => q.quizId !== quizId) });
        },

        clearAll() {
            set({ quizzes: [] });
        },

        hasQuiz(quizId) {
            return get().quizzes.some((q) => q.quizId === quizId);
        },
    }),
    {
      name: 'unfinished-quiz-storage', // localStorage key
    }
  )
);
